// extracted by mini-css-extract-plugin
export var carrierIcon = "_un-0";
export var carrierLogo = "_un-1";
export var detailsSection = "_un-2";